import { Injectable } from "@angular/core";
import { BrandEntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { buildBrandEntity } from "@youm-front/brand/utils/factory";
import { map } from "rxjs/operators";

@Injectable()
export class BrandService {
  constructor(private readonly apiService: ApiService) {}

  brandGetList() {
    return this.apiService
      .get<BrandEntityRaw[]>("me/brands")
      .pipe(map((_) => _.map((_) => buildBrandEntity(_))));
  }
}
